// Håller reda på om sidan körs via en extern delningslänk (entreprenör/projektör).
// AI-hjälpmedlen skickar då med token i stället för en inloggad session.
let currentToken: string | null = null;

export const setExternalShareToken = (token: string | null) => {
  currentToken = token && token.length >= 32 ? token : null;
};

export const getExternalShareToken = (): string | null => currentToken;

export const isExternalShareSession = (): boolean => currentToken !== null;

/** Extra headers till supabase.functions.invoke när sessionen är extern. */
export const externalShareHeaders = (): Record<string, string> =>
  currentToken ? { "x-share-token": currentToken } : {};
